/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React, {useEffect, useState} from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";
import {WealthyEnv} from "helpers";

const homeUrl = WealthyEnv.URL;

const propTypes = {
  isWhite: PropTypes.bool,
  sticky: PropTypes.bool
};

const defaultProps = {
  sticky: true,
  isWhite: false
};

const Header = ({
  sticky,
  isWhite
}) => {
  useEffect(() => {
    if (isWhite) {
      const header = document.querySelector(".header");
      header.classList.add("is-white");
      document.querySelector(".white-logo").src = `${WealthyEnv.HOMEPAGE_CDN_URL}/wl_colorful_logo.png`;
    }
  }, [isWhite]);

  useEffect(() => {
    if (window.innerWidth >= "1080" && sticky) {
      window.addEventListener("scroll", () => {
        const windowScroll = window.scrollY;
        const screenHeight = window.innerHeight;

        const header = document.querySelector(".header");
        if (header && windowScroll > screenHeight && !Array.from(header.classList).includes("fixed")) {
          header.classList.add("fixed");
          if (!isWhite) {
            document.querySelector(".white-logo").src = `${WealthyEnv.HOMEPAGE_CDN_URL}/wl_colorful_logo.png`;
          }
        } else if (header && windowScroll < 60 && Array.from(header.classList).includes("fixed")) {
          header.classList.remove("fixed");
          if (!isWhite) {
            document.querySelector(".white-logo").src = `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-logo-white.png`;
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    const {pathname, hash} = window.location;
    if (window.innerWidth > "1080") {
      const links = Array.from (document.querySelectorAll(".header-link"));
      const clients = document.querySelector(".header-clients");
      const partners = document.querySelector(".header-partners");
      const greyMatter = document.querySelector(".header-grey-matter");

      links.forEach(link => {
        const isPathNameSame = link.pathname === pathname;
        let isParameterMatched = false;
        let params = link.dataset.params || "";
        params = params.split(",");
        params.forEach(param => {
          if (param && pathname.includes(param)) {
            isParameterMatched = true;
          }
        });

        if (isPathNameSame || isParameterMatched) {
          if (!link.hash) {
            link.parentElement.classList.add("active-link");
            if (isPathNameSame) {
              link.parentElement.classList.add("disabled-link");
            }
          }
          if (Array.from(link.classList).includes("header-partners__link")) {
            partners.classList.add("expand");
            partners.classList.add("active-link");
          } else if (Array.from(link.classList).includes("header-clients__link")) {
            clients.classList.add("expand");
          } else {
            greyMatter.classList.add("expand");
            greyMatter.classList.add("active-link");
          }
        }
      });
    } else {
      const links = Array.from (document.querySelectorAll(".menu-link"));

      links.forEach(link => {
        if (link.pathname === pathname) {
          if (Array.from(link.classList).includes("menu-clients__link")) {
            document.querySelector(".menu-clients__list").classList.add("expand-list");
            document.querySelector(".menu-clients .expand-icon__btn").classList.add("rotate-down");
          } else if (Array.from(link.classList).includes("menu-partners__link")) {
            document.querySelector(".menu-partners__list").classList.add("expand-list");
            document.querySelector(".menu-partners .expand-icon__btn").classList.add("rotate-down");
          } else {
            document.querySelector(".menu-grey-matter__list").classList.add("expand-list");
            document.querySelector(".menu-grey-matter .expand-icon__btn").classList.add("rotate-down");
          }
          link.classList.add("disabled-link");
        }
      });
    }
  }, []);

  const toggleHamburgerMenu = () => {
    document.querySelector(".hamburger-icon__btn").classList.toggle("toggle");
    document.body.classList.toggle("overflow-hidden");
  };

  const collapseHamburgerMenu = () => {
    document.querySelector(".hamburger-icon__btn").classList.toggle("toggle");
    document.body.classList.toggle("overflow-hidden");
  };

  const expandMenuItem = (e, className) => {
    const current = document.querySelector(".expand-list");
    const rotator = document.querySelector(".rotate-down");

    const selector = document.querySelector(`.${className}`);

    if (current && current === selector) {
      current.classList.toggle("expand-list");
      rotator.classList.toggle("rotate-down");
    } else if (current && rotator) {
      current.classList.toggle("expand-list");
      rotator.classList.toggle("rotate-down");
      selector.classList.toggle("expand-list");
      Array.from(e.currentTarget.children)[1].classList.toggle("rotate-down");
    } else {
      selector.classList.toggle("expand-list");
      Array.from(e.currentTarget.children)[1].classList.toggle("rotate-down");
    }
  };

  return (
    <header
      className="header"
      style={{
        height: "55px",
        width: "100vw",
        zIndex: "5",
        display: "flex"
      }}
    >
      <nav
        className="nav-bar"
        style={{
          display: "flex",
          width: "95%",
          margin: "0 auto"}}
      >
        <div className="header__logo">
          <SafeLink
            href={`${homeUrl}`}
            rel="noopener noreferrer"
            style={{
              cursor: "pointer",
              marginRight: "20px"
            }}
          >
            <img
              alt="wealthy-logo"
              className="white-logo"
              loading="lazy"
              src={`${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-logo-white.png`}
            />
          </SafeLink>
        </div>
        <div className="desktop-nav" >
          <div className="header-clients">
            <SafeLink
              className="header-clients__link header-link"
              href={`${homeUrl}`}
              style={{
                fontSize: "16px",
                textAlign: "left",
                textTransform: "uppercase",
                textDecoration: "none",
                fontWeight: 900
              }}
            >
            Clients
            </SafeLink>
          </div>
          <ul className="header-clients__list">
            <li className="header-clients__item header-clients__manage">
              <SafeLink
                className="header-clients__link header-link"
                href={`${homeUrl}/tracker`}
              >
                Manage
              </SafeLink>
            </li>
            <li className="header-clients__item header-clients__invest">
              <SafeLink
                className="header-clients__link header-link"
                href={`${homeUrl}#investment-products`}
              >
                Invest
              </SafeLink>
            </li>
            <li className="header-clients__item header-clients__privilege">
              <SafeLink
                className="header-clients__link header-link"
                href={`${homeUrl}/privilege`}
              >
                Privilege
              </SafeLink>
            </li>
            <li
              className="header-clients__item header-clients__know-more"
            >
              <SafeLink
                className="header-clients__link dropdown-link header-link"
                href={`${homeUrl}/why-wealthy`}
              >
                Know More<span className="caret">&nbsp;</span>
              </SafeLink>
              <ul className="dropdown-menu">
                <li className="dropdown-menu__item">
                  <SafeLink
                    className="header-clients__link header-link dropdown-menu__link"
                    href={`${homeUrl}/about-us`}
                  >
                    <p className="offering-name">About us</p>
                  </SafeLink>
                </li>
                <li className="dropdown-menu__item">
                  <SafeLink
                    className="dropdown-menu__link"
                    href={`${homeUrl}/insights`}
                  >
                    <p className="offering-name">Insights</p>
                  </SafeLink>
                </li>
                <li className="dropdown-menu__item">
                  <SafeLink
                    className="header-clients__link header-link dropdown-menu__link"
                    href={`${homeUrl}/methodology`}
                  >
                    <p className="offering-name">Methodology</p>
                  </SafeLink>
                </li>
                <li className="dropdown-menu__item">
                  <SafeLink
                    className="header-clients__link header-link dropdown-menu__link"
                    href={`${homeUrl}/faqs`}
                  >
                    <p className="offering-name">FAQs</p>
                  </SafeLink>
                </li>
                <li>
                  <SafeLink
                    className="header-clients__link header-link dropdown-menu__link"
                    href={`${homeUrl}/privacy`}
                    style={{display: "none"}}
                  >
                    <p className="offering-name">Privacy Policy</p>
                  </SafeLink>
                </li>
              </ul>
            </li>
          </ul>
          <div className="header-partners">
            <SafeLink
              className="header-partners__link header-link"
              href={`${homeUrl}/partner`}
              style={{
                fontSize: "16px",
                textAlign: "left",
                textTransform: "uppercase",
                textDecoration: "none",
                fontWeight: 900
              }}
            >
            Wealth Partners
            </SafeLink>
          </div>
          <ul className="header-partners__list">
            <li className="header-partners__item">
              <SafeLink
                className="header-partners__link"
                href="http://onelink.to/rpg4hm"
              >
                  Experience Wealthy
              </SafeLink>
            </li>
          </ul>
          <div className="header-grey-matter">
            <SafeLink
              className="header-grey-matter__link header-link"
              href={`${homeUrl}/grey-matter`}
              style={{
                fontSize: "16px",
                textAlign: "left",
                textTransform: "uppercase",
                textDecoration: "none",
                fontWeight: 900
              }}
            >
            Grey Matter
            </SafeLink>
          </div>
          <ul className="header-grey-matter__list">
            <li className="header-grey-matter__item">
              <SafeLink
                className="header-grey-matter__link header-link"
                data-params={["insights", "articles"]}
                href={`${homeUrl}/insights`}
              >
                Insights
              </SafeLink>
            </li>
            <li className="header-grey-matter__item">
              <SafeLink
                className="header-grey-matter__link header-link"
                data-params={["money-order", "newsletters"]}
                href={`${homeUrl}/money-order`}
              >
                Money Order
              </SafeLink>
            </li>
            <li className="header-grey-matter__item">
              <SafeLink
                className="header-grey-matter__link header-link"
                data-params={["stories", "interviews"]}
                href={`${homeUrl}/stories`}
              >
                Stories
              </SafeLink>
            </li>
          </ul>
          <ul className="header-clients__buttons">
            <li>
              <SafeLink
                className="login-btn"
                href="http://onelink.to/nu4cnw"
              >Login</SafeLink>
            </li>
            <li>
              <SafeLink
                className="download-btn"
                href="http://onelink.to/rpg4hm"
              >DOWNLOAD APP</SafeLink>
            </li>
          </ul>
          <ul className="header-grey-matter__buttons">
            <li>
              <SafeLink
                className="subscribe-btn"
                href="#subscribe"
              >SUBSCRIBE</SafeLink>
            </li>
          </ul>
        </div>
        <div className="mobile-nav">
          <div
            className="hamburger-icon__btn"
            onClick={toggleHamburgerMenu}
          >
            <button
              className="hamburger-icon"
            />
          </div>
          <ul className="hamburger-menu">
            <li
              className="menu-clients"
              onClick={(e) => expandMenuItem(e, "menu-clients__list")}
            >
              <p
                className="menu-clients__link--main"
                style={{color: "#193076", fontWeight: 700, fontSize: "14px"}}
              >
                CLIENTS
              </p>
              <div className="expand-icon__btn">
                <button className="expand-icon" />
              </div>
            </li>
            <ul className="menu-clients__list">
              <li className="menu-clients__item">
                <SafeLink
                  className="menu-clients__link menu-link"
                  href={`${homeUrl}/for-investors`}
                >
                  Home
                </SafeLink>
              </li>
              <li className="menu-clients__item">
                <SafeLink
                  className="menu-clients__link menu-link"
                  href={`${homeUrl}/tracker`}
                >
                  Manage
                </SafeLink>
              </li>
              <li  className="menu-clients__item">
                <SafeLink
                  className="menu-clients__link menu-link"
                  href={`${homeUrl}/for-investors#home-products-section`}
                  onClick={collapseHamburgerMenu}
                >
                  Invest
                </SafeLink>
              </li>
              <li className="menu-clients__item">
                <SafeLink
                  className="menu-clients__link menu-link"
                  href={`${homeUrl}/privilege`}
                >
                  Privilege
                </SafeLink>
              </li>
            </ul>
            <li
              className="menu-partners"
              onClick={(e) => expandMenuItem(e, "menu-partners__list")}
            >
              <p
                className="menu-partners__link--main"
                style={{color: "#193076", fontWeight: 700, fontSize: "14px"}}
              >
                WEALTH MANAGERS
              </p>
              <div className="expand-icon__btn">
                <button className="expand-icon" />
              </div>
            </li>
            <ul className="menu-partners__list">
              <li className="menu-partners__item">
                <SafeLink
                  className="menu-partners__link menu-link"
                  href={`${homeUrl}/partner`}
                >Home</SafeLink>
              </li>
              <li className="menu-partners__item">
                <SafeLink
                  className="menu-partners__link"
                  href="http://onelink.to/rpg4hm"
                >Experience</SafeLink>
              </li>
            </ul>
            <li
              className="menu-grey-matter"
              onClick={(e) => expandMenuItem(e, "menu-grey-matter__list")}
            >
              <p
                className="menu-grey-matter__link--main"
                style={{color: "#193076", fontWeight: 700, fontSize: "14px"}}
              >
                GREY MATTER
              </p>
              <div className="expand-icon__btn">
                <button className="expand-icon" />
              </div>
            </li>
            <ul className="menu-grey-matter__list">
              <li className="menu-grey-matter__item">
                <SafeLink
                  className="menu-grey-matter__link menu-link"
                  href={`${homeUrl}/grey-matter`}
                >Home</SafeLink>
              </li>
              <li className="menu-grey-matter__item">
                <SafeLink
                  className="menu-grey-matter__link menu-link"
                  href={`${homeUrl}/insights`}
                >Insights</SafeLink>
              </li>
              <li className="menu-grey-matter__item">
                <SafeLink
                  className="menu-grey-matter__link menu-link"
                  href={`${homeUrl}/stories`}
                >Stories</SafeLink>
              </li>
              <li className="menu-grey-matter__item">
                <SafeLink
                  className="menu-grey-matter__link menu-link"
                  href={`${homeUrl}/money-order`}
                >Money Order</SafeLink>
              </li>
            </ul>
            <li
              className="menu-know-more"
              onClick={(e) => expandMenuItem(e, "know-more__list")}
            >
              <p
                style={{color: "#193076", fontWeight: 700, fontSize: "14px"}}
              >KNOW MORE</p>
              <div className="expand-icon__btn">
                <button className="expand-icon" />
              </div>
            </li>
            <ul className="know-more__list">
              <li className="know-more__item">
                <SafeLink
                  className="know-more__link"
                  href={`${homeUrl}/about-us`}
                >About Us</SafeLink>
              </li>
              <li className="know-more__item">
                <SafeLink
                  className="know-more__link"
                  href={`${homeUrl}/insights`}
                >Insights</SafeLink>
              </li>
              <li className="know-more__item">
                <SafeLink
                  className="know-more__link"
                  href={`${homeUrl}/methodology`}
                >Methodology</SafeLink>
              </li>
              <li className="know-more__item">
                <SafeLink
                  className="know-more__link"
                  href={`${homeUrl}/faqs`}
                >FAQs</SafeLink>
              </li>
            </ul>
            <ul className="menu-auth__list">
              <li className="menu-auth__item">
                <SafeLink
                  className="menu-auth__link"
                  href="http://onelink.to/nu4cnw"
                >
                  LOGIN
                </SafeLink>
              </li>
            </ul>
          </ul>
          <div
            className="hamburger-menu__overlay"
            onClick={collapseHamburgerMenu}
          />
        </div>
      </nav>
    </header>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;

